import { TagPrefix } from '../enums/machine-models.enums';
import { BallType } from '../enums/machine.enums';
import { IMachine } from '../interfaces/i-machine';
import { IEvalModelResult } from '../interfaces/modelling/i-eval-models';
import { IMachineModel } from '../interfaces/modelling/i-machine-model';

/** uses details from machine to construct the active model_key value,
 * ignores whether it's defined in model_ids
 * defaults to 'NO-KEY' if key would be empty */
export const getModelKey = (machine: Partial<IMachine>): string => {
  return machine.ball_type || 'NO-KEY';
};

export const getModelKeyFromModel = (model: Partial<IMachineModel>): string => {
  // updated logic for new modelling shape
  if (model.ball_type) {
    return model.ball_type;
  }

  const tag = model.tags?.find((t) => t.startsWith(`${TagPrefix.BallType}:`));
  if (tag) {
    return `${tag.split(':')[1]}`;
  }

  return 'NO-KEY';
};

// ! deprecate if unused
// kind of janky but works even if the interfaces aren't aligned
export const getModelKeyFromEvalResult = (model: IEvalModelResult): string => {
  return getModelKeyFromModel({
    ball_type: model.ball_type,
    tags: model.tags,
  });
};

/** generates empty key-value pairs for every possible permutation of keys */
export const generateModelKeys = (currentDict?: {
  [key: string]: string;
}): { [key: string]: string } => {
  const output: { [key: string]: string } = {};

  Object.values(BallType)
    .sort()
    .forEach((ball) => {
      /** should match what comes out of getModelKey */
      const key = `${ball}`;
      output[key] = '';
    });

  if (currentDict) {
    /** keep values from current dictionary */
    Object.keys(currentDict)
      .sort()
      .forEach((key) => (output[key] = currentDict[key]));
  }

  return output;
};

/** returns model_id (if any) based on the active model_key and model_ids dictionary */
export const getMachineActiveModelID = (
  machine: Partial<IMachine>
): string | undefined => {
  const key = getModelKey(machine);
  return machine.model_ids?.[key];
};
